export enum ProductGroupRotation {
	Front = 'front',
	Side = 'side',
    FrontRotated = 'front-rotated', // TODO: need to delete after deploy new product position
	FrontRotatedRight = 'front-rotated-right',
    FrontRotatedLeft = 'front-rotated-left',
	Top = 'top'
}